import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">连接我们</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">期待与每一位漫画创作者和读者的交流</p>
        </div>

        <div className="max-w-2xl mx-auto p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70">
          <h3 className="font-heading font-bold text-lg text-foreground-900 mb-3">{contactInfo.title}</h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">{contactInfo.desc}</p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-center gap-3 p-3 rounded-lg bg-background-50">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-mail-line"></i>
              </div>
              <div className="min-w-0">
                <div className="text-[11px] text-foreground-400">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 rounded-lg bg-background-50">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                <i className="ri-qq-line"></i>
              </div>
              <div className="min-w-0">
                <div className="text-[11px] text-foreground-400">QQ交流群</div>
                <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.qq}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 rounded-lg bg-background-50">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-wechat-line"></i>
              </div>
              <div className="min-w-0">
                <div className="text-[11px] text-foreground-400">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.wechat}</div>
              </div>
            </div>
          </div>
          <p className="text-xs text-foreground-400 mt-4 text-center">{contactInfo.tips}</p>
        </div>
      </div>
    </section>
  );
}